import { API_ROUTES } from 'Utilities/routes';

import * as accountMapper from '../../server/api/mappers/account';
import { getAccountBiddingHistoryEndpointAndQueryParams } from '../../server/helpers';
import isomorphicApi from '../../utilities/helpers/isomorphicApi';
import axios from '../axios';
import { resolveParams } from '../services.helpers';

export const getAccountPurchasesCompleteStatusCounts = async (params, ctx) =>
	isomorphicApi(ctx, {
		browser: async () => axios.get(`${API_ROUTES.BIDDING_HISTORY_STATUS_COUNTS}${resolveParams(params)}`),
		server: async (api) => {
			const { dealerId } = ctx.req.user;
			const counts = await api.getAccountPurchasesCompleteStatusCounts({ dealerId, ...params });

			return accountMapper.statusCounts(counts.data);
		},
	});

export const getAccountCounts = async (params, ctx) =>
	isomorphicApi(ctx, {
		browser: async () => axios.get(API_ROUTES.BIDDING_HISTORY_COUNTS),
		server: async (api) => {
			const { dealerId } = ctx.req.user;
			const counts = await api.getHistoryCounts({ dealerId });

			return accountMapper.counts(counts.data);
		},
	});

const getBiddingHistorySectionData = async (params, ctx) =>
	isomorphicApi(ctx, {
		browser: async () => {
			const { category, slug } = params;
			return axios.get(`/api/account/bidding-history/${category}/${slug}${resolveParams(params)}`);
		},
		server: async (api) => {
			const { dealerId } = ctx.req.user;
			const { features } = ctx.req;

			const { query, url } = getAccountBiddingHistoryEndpointAndQueryParams(params);

			const vehicles = await api.getHistorySectionData(url, { ...query, dealerId }, features);

			return accountMapper.accountSection({ vehicles });
		},
	});

export const getAccountSectionData = async (params, ctx) => {
	return getBiddingHistorySectionData(params, ctx);
};

export const changeAccountPurchaseDeliveredStatus = async (bidId, isDelivered) => {
	const res = await axios.post(`/api/bids/${bidId}/update-delivered-status`, { isDelivered });

	return res.data;
};
